import { render, staticRenderFns } from "./SplitRevenueComponent.vue?vue&type=template&id=bf889362&scoped=true"
import script from "./SplitRevenueComponent.vue?vue&type=script&lang=ts"
export * from "./SplitRevenueComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf889362",
  null
  
)

export default component.exports